var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "mmc-dashboard-cardItemGradientPattern",
    patternUnits: "objectBoundingBox",
    width: 1,
    height: 1,
    viewBox: "0 0 20 21"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -6.70915,
    cy: 20.5947,
    r: 22.4575,
    fill: "url(#paint0_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4286,
    cy: 18.3865,
    r: 25.0715,
    fill: "url(#paint1_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.56397,
    cy: 0.905033,
    r: 25.0715,
    fill: "url(#paint2_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.56397,
    cy: 0.905033,
    r: 25.0715,
    fill: "url(#paint3_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6.70915,
    cy: 20.5947,
    r: 22.4575,
    fill: "url(#paint4_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4286,
    cy: 18.3865,
    r: 25.0715,
    fill: "url(#paint5_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6.70915,
    cy: 20.5947,
    r: 22.4575,
    fill: "url(#paint6_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4286,
    cy: 18.3865,
    r: 25.0715,
    fill: "url(#paint7_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.56397,
    cy: 0.905033,
    r: 25.0715,
    fill: "url(#paint8_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4286,
    cy: 18.3865,
    r: 25.0715,
    fill: "url(#paint9_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.56397,
    cy: 0.905033,
    r: 25.0715,
    fill: "url(#paint10_radial_7125_612)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6.70915,
    cy: 20.5947,
    r: 22.4575,
    fill: "url(#paint11_radial_7125_612)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.70915 20.5947) rotate(90) scale(22.4575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3063E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3063E4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4286 18.3865) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB2FD7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.56397 0.905033) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46ADDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46ADDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.56397 0.905033) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46ADDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46ADDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.70915 20.5947) rotate(90) scale(22.4575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3063E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3063E4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4286 18.3865) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB2FD7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.70915 20.5947) rotate(90) scale(22.4575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3063E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3063E4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4286 18.3865) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB2FD7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.56397 0.905033) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46ADDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46ADDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4286 18.3865) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB2FD7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.56397 0.905033) rotate(90) scale(25.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46ADDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46ADDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_7125_612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.70915 20.5947) rotate(90) scale(22.4575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3063E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3063E4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.fab7e1d42ff8c81e76c7c0d1a89e3c85.svg";
export { ForwardRef as ReactComponent };